import { AxiosInstance, AxiosPromise } from 'axios';
import {
  CreateOrderParamPayload,
  LoadTenderStatusPayload,
  UpdateOrderParamPayload,
  UpdateClientNoteRequest,
  GetOrdersResponse,
  GetOrdersRequest,
  FindByVinResponse,
} from './OrderServices.types';

import { OrderPartiesService } from './services';
import { LegacyOrder } from '../../../../types/LegacyOrder';
import { Order } from '../../../../types/Order';

export class OrderSevices {
  instance: AxiosInstance;
  parties: OrderPartiesService;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
    this.parties = new OrderPartiesService(instance);
  }

  get(orderGuid: string) {
    return this.instance.get<Order>(`/order/${orderGuid}`);
  }

  create(payload: CreateOrderParamPayload): AxiosPromise<Order> {
    if (!payload) throw new Error('No payload was provided');
    return this.instance.post('/order', payload);
  }

  update(payload: UpdateOrderParamPayload): AxiosPromise<LegacyOrder> {
    if (!payload) throw new Error('No payload was provided');
    return this.instance.patch('/order', payload);
  }

  getOrders(request: GetOrdersRequest): AxiosPromise<GetOrdersResponse> {
    return this.instance.post(`/order/getorders`, request.body);
  }

  updateClientNote(request: UpdateClientNoteRequest) {
    return this.instance.put(`/order/${request.routeParams.orderGuid}/clientNote`, request.body);
  }

  acceptLoadTender(orderGuid: string): AxiosPromise<LoadTenderStatusPayload> {
    return this.instance.put(`/order/${orderGuid}/tender/accept`);
  }

  declineLoadTender(orderGuid: string, reason: string): AxiosPromise<LoadTenderStatusPayload> {
    return this.instance.put(`/order/${orderGuid}/tender/reject`, { reason });
  }

  findByVin(vin: string): AxiosPromise<FindByVinResponse> {
    return this.instance.get(`/order/find_by_vin/${vin}`);
  }
}
